import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE = 'Timber & Thread Co.';
const SITE_URL = 'https://timberandthread.com.au';
const DEFAULT_OG = 'https://timberandthread.com.au/og-image.jpg';

/**
 * Per-page SEO tags — unique <title>, <meta description>, canonical, and
 * Open Graph for every route. Pass an optional `path` (without origin)
 * to set the canonical / og:url; otherwise the current location is used at
 * render time.
 */
const SEO = ({ title, description, path, image, noIndex = false }) => {
  const pageTitle = title ? `${title} — ${SITE}` : `${SITE} — Premium bouclé bed frames & solid timber furniture`;
  const desc = description || 'Premium bouclé bed frames, modular sofas and solid timber furniture. Designed and made in Australia. Free Australia-wide delivery.';
  const url = path ? `${SITE_URL}${path}` : SITE_URL;
  const ogImage = image || DEFAULT_OG;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}
      {/* Open Graph */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE} />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
